export default "__VITE_PUBLIC_ASSET__6664d140__"